import { createSlice } from '@reduxjs/toolkit';

// Load cart state from localStorage if available
const loadState = () => {
  try {
    const serializedState = localStorage.getItem('cart');
    console.log('Loading cart state from localStorage:', serializedState);
    if (serializedState === null) {
      return {
        items: [],
        total: 0,
      };
    }
    const state = JSON.parse(serializedState);
    // Validate state structure
    if (!state.items || !Array.isArray(state.items)) {
      console.warn('Invalid cart state structure, resetting to default');
      return {
        items: [],
        total: 0,
      };
    }
    return state;
  } catch (err) {
    console.error('Error loading cart state:', err);
    return {
      items: [],
      total: 0,
    };
  }
};

const saveState = (state) => {
  try {
    // Ensure state has valid structure before saving
    const validState = {
      items: Array.isArray(state.items) ? state.items : [],
      total: typeof state.total === 'number' ? state.total : 0,
    };
    const serializedState = JSON.stringify(validState);
    console.log('Saving cart state to localStorage:', serializedState);
    localStorage.setItem('cart', serializedState);
  } catch (err) {
    console.error('Error saving cart state:', err);
  }
};

const calculateTotal = (items) => {
  if (!Array.isArray(items)) return 0;
  return items.reduce((total, item) => {
    const price = parseFloat(item.price) || 0;
    const quantity = parseInt(item.quantity) || 0;
    return total + (price * quantity);
  }, 0);
};

const initialState = loadState();

const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    addItem: (state, action) => {
      console.log('Cart addItem reducer called with:', action.payload);
      const existingItem = state.items.find(item => item.id === action.payload.id);
      if (existingItem) {
        existingItem.quantity += 1;
      } else {
        state.items.push({ ...action.payload, quantity: 1 });
      }
      state.total = calculateTotal(state.items);
      console.log('New cart state after adding item:', state);
      saveState(state);
    },
    removeItem: (state, action) => {
      console.log('Cart removeItem reducer called with:', action.payload);
      state.items = state.items.filter(item => item.id !== action.payload);
      state.total = calculateTotal(state.items);
      console.log('New cart state after removing item:', state);
      saveState(state);
    },
    updateQuantity: (state, action) => {
      console.log('Cart updateQuantity reducer called with:', action.payload);
      const { id, quantity } = action.payload;
      const item = state.items.find(item => item.id === id);
      if (item) {
        item.quantity = quantity;
        state.total = calculateTotal(state.items);
        console.log('New cart state after updating quantity:', state);
        saveState(state);
      }
    },
    clearCart: (state) => {
      console.log('Cart clearCart reducer called');
      state.items = [];
      state.total = 0;
      console.log('New cart state after clearing:', state);
      saveState(state);
    },
  },
});

export const { addItem, removeItem, updateQuantity, clearCart } = cartSlice.actions;
export default cartSlice.reducer;
